import { jsx as _jsx } from "react/jsx-runtime";
import { SimpleGrid } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PageWrapper, ToolCard } from '@/components';
import { ROUTE } from '@/types';
export const Tools = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (_jsx(PageWrapper, Object.assign({ title: t('page:tool.title') }, { children: _jsx(SimpleGrid, Object.assign({ spacing: '4', templateColumns: 'repeat(auto-fill, minmax(200px, 1fr))' }, { children: _jsx(ToolCard, { buttonText: t('page:tool.time-warp.btn-view'), description: t('page:tool.time-warp.description'), icon: 'calendar-time', onClick: () => navigate(ROUTE.TIME_WARP), title: t('page:tool.time-warp.title') }) })) })));
};
